'use strict';

import { Entity } from '../Entity';
import { Ind } from './Ind';

export class IndConnection extends Entity {
  protected id;
  protected connectionTo: Ind;
  protected connectionReference;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    if (data.connectionTo) {
      const connectionTo = new Ind();
      connectionTo.hydrate(data.connectionTo);

      this.connectionTo = connectionTo;
    }
    this.connectionReference = data.connectionReference;
  }

  public getId() {
    return this.id;
  }

  public getConnectionTo() {
    return this.connectionTo;
  }

  public getConnectionReference() {
    return this.connectionReference;
  }
}
